import "./index.css";
import {createRoot} from 'react-dom/client';
import CM from "./appl/model/system/CM";
import App from "./appl/view/App";

CM.get().init(CM.STD_DARK);

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<>
  <App/>
</>);